import type { LaneId } from "@fate-kingdom/engine";

export function LaneSlot3D({
  laneId,
  position,
  legal,
  selected,
  pulse,
  onActivate,
}: {
  readonly laneId: LaneId;
  readonly position: readonly [number, number, number];
  readonly legal: boolean;
  readonly selected: boolean;
  readonly pulse: boolean;
  readonly onActivate?: ((laneId: LaneId) => void) | undefined;
}) {
  const highlighted = legal || selected || pulse;
  return (
    <group position={[position[0], position[1], position[2]]}>
      <mesh receiveShadow rotation={[-Math.PI / 2, 0, 0]}>
        <planeGeometry args={[1.62, 2.15]} />
        <meshStandardMaterial
          color={legal ? "#2c684d" : selected ? "#765f2b" : "#142c32"}
          emissive={legal ? "#4fbc79" : selected ? "#b9903e" : "#000000"}
          emissiveIntensity={highlighted ? 0.28 : 0}
          transparent
          opacity={highlighted ? 0.62 : 0.22}
          roughness={0.9}
        />
      </mesh>
      <mesh
        position={[0, 0.035, 0]}
        rotation={[-Math.PI / 2, 0, 0]}
        onPointerDown={(event) => event.stopPropagation()}
        onClick={(event) => {
          event.stopPropagation();
          if (legal) onActivate?.(laneId);
        }}
      >
        <planeGeometry args={[1.74, 2.3]} />
        <meshBasicMaterial transparent opacity={0} />
      </mesh>
    </group>
  );
}
